module.exports = __webpack_public_path__ + "img/soldier-2.c14bf871.png";